import hasAncestorOfClass from "./hasAncestorOfClass";
import isEditable from "./isEditable";

export default () => {
  return (
    (isEditable(document.activeElement) && !document.activeElement.classList.contains("tableCellClipboardCatcher")) ||
    hasAncestorOfClass(document.activeElement, "calendarPickerPopover")
  );
};
